// @flow
import React, { useState } from "react";
import PackageList from "../../welcome-dashboard/components/payment/PackageList";
import { infoMessages } from "./deviceInfoMessage";
import Dialog from "../../../base/ui/components/web/Dialog";
import { ct } from "../../constant-Utils";
import Subscription from "../../welcome-dashboard/components/payment/Subscription";

const UserSubscription = (props) => {
    const [plansCount, setPlansCount] = useState(0);
    const _closeHelpModal = () => {
        props.closeSubscription(true)
    }

    return (
        <>
            {

                <Dialog
                    disableAutoHideOnSubmit={true}
                    disableBackdropClose={true}
                    hideCloseButton={true}
                    onCancel={() => _closeHelpModal()}
                    cancel={{ translationKey: ct("Translate.buttonTitle.closeSmall") }}
                    ok={{ hidden: true }}
                    titleKey={ct("Translate.typography.subscription")}
                    rtaClassName="invite-modal-dialog"
                    testId="user-subscription-modal"
                    size="large"
                    zIndex={999}
                >
                    {props?.socialTrigger != undefined
                        ? <Subscription  socialTrigger={true} /> :
                        <PackageList
                            {...props}
                            hideLogo={true}
                            handleSkip={_closeHelpModal}
                            additionalTitle={infoMessages.selectSubscription}
                            showPackageOnly={false}
                            setPlansCount={setPlansCount}
                            plansCount={plansCount}
                            requestFrom="modal"
                        />
                    }
                </Dialog>
            }
        </>
    )

}

export default UserSubscription;